/* eslint-disable no-nested-ternary */
/* eslint-disable indent */

// Importing components
import { ConditionalComponent, FakeLoader } from 'components';
// import PageTableMessage from './PageTableMessage';

// Importing styles
import './tableContent.scss';

// Importing libraries
import { ERROR } from '../../utils/helperMethods';
import PageTableMessage from './PageTableMessage';
import React from 'react';
import PropTypes from 'prop-types';

const NO_DATA_FOUND = {
    message: 'No Data Found',
    subtitle: 'Data will be visible here',
    imageSrc: 'NoDataFound',
};

const TableContent = props => {
    const { columns, data, error, isLoading, noDataError } = props;
    const noDataFoundError = noDataError ? noDataError : NO_DATA_FOUND;
    return (
        <>
            {/* Main table wrapper */}
            <div
                className={`table-wrapper ${
                    !data || data.length <= 0 || !error ? 'no-data' : ''
                }`}
            >
                <table>
                    <thead>
                        <tr>
                            <ConditionalComponent
                                isVisible={columns && columns.length}
                            >
                                {columns.map((columnData, idx) => {
                                    return (
                                        <th
                                            key={idx}
                                            className="head"
                                            colSpan={1}
                                        >
                                            {columnData.header}
                                        </th>
                                    );
                                })}
                            </ConditionalComponent>
                        </tr>
                    </thead>
                    {/* TableContent body */}
                    <tbody>
                        {/* Display loader if data is loading */}
                        {isLoading ? <FakeLoader withMask /> : null}
                        {/* Render table rows if data is available */}
                        <ConditionalComponent
                            isVisible={data && data.length && !error}
                        >
                            <>
                                {data.map((row, index) => (
                                    <tr key={index} className="row">
                                        {columns.map(
                                            (
                                                { accessor, render },
                                                keyIndex
                                            ) => {
                                                return (
                                                    <td
                                                        key={keyIndex}
                                                        className="data"
                                                        colSpan={1}
                                                    >
                                                        {render &&
                                                        typeof render ===
                                                            'function'
                                                            ? render(row, index)
                                                            : row[accessor] ||
                                                              '-'}
                                                    </td>
                                                );
                                            }
                                        )}
                                    </tr>
                                ))}
                            </>
                        </ConditionalComponent>
                    </tbody>
                </table>

                {/* Display error message or no data message */}
                {error && !isLoading ? (
                    <PageTableMessage {...ERROR(error)} isError />
                ) : (!data || data.length <= 0) && !isLoading ? (
                    <PageTableMessage {...noDataFoundError} />
                ) : (
                    <></>
                )}
            </div>
        </>
    );
};
// PropType validation for TableContent component
TableContent.propTypes = {
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    error: PropTypes.string,
    pagination: PropTypes.object.isRequired,
    fetchData: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
};
export default TableContent;
